import { Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import Tabs, { TabHeader, TabPanels } from 'components/Tabs';
import ClientInformation from 'containers/Integrations/Paychex/ClientInformation';

import PaychexTask from './PaychexTask';
import PaychexWorker from './PaychexWorker';
import Timeoff from './Timeoff';

const MappingTabs = () => {
  const { t } = useTranslation(['integrations']);
  const tabHeaders = [
    { label: t('integrations:paychexCsv.paychexWorker') },
    { label: t('integrations:paychexCsv.paychexTask') },
    { label: t('integrations:paychexCsv.timeOff') },
  ];
  const tabPanels = [{ panel: <PaychexWorker /> }, { panel: <PaychexTask /> }, { panel: <Timeoff /> }];

  return (
    <Tabs>
      <Flex justifyContent="space-between" flexDirection={{ base: 'column', md: 'row' }}>
        <TabHeader tabHeaders={tabHeaders} />
        <ClientInformation />
      </Flex>

      <TabPanels tabPanels={tabPanels} />
    </Tabs>
  );
};
export default MappingTabs;
